import { TaxonomyFormPage } from '../taxonomy/TaxonomyFormPage.js';

export function CarFeatureFormPage() {
  return (
    <TaxonomyFormPage
      config={{
        title: 'Feature',
        apiPath: '/car-features',
        basePath: '/car-features',
        resource: 'carFeature',
        fields: [{ name: 'icon', label: 'Icon', type: 'text', hint: 'Optional icon key' }],
      }}
    />
  );
}
